import PageHero from "@/components/site/PageHero";
import ServicesGrid from "@/components/site/ServicesGrid";
import { Reviews } from "@/components/site/Sections";
import ContactBlock from "@/components/site/ContactBlock";
import { usePageMeta } from "@/components/site/usePageMeta";
import { useLang } from "@/i18n/LangContext";

export default function Services() {
  const { tr } = useLang();
  usePageMeta(
    tr("Dental Services in Nicaragua – Implants, Braces, Cosmetic", "Servicios Dentales en Nicaragua – Implantes, Brackets, Estética"),
    tr("Root canals, children's dentistry, Damon System braces, orthodontics, dental implants, Digital Smile Design, crowns, cosmetic and restorative dentistry, dentures.", "Endodoncias, odontopediatría, brackets Sistema Damon, ortodoncia, implantes dentales, Diseño de Sonrisa Digital, coronas, odontología estética y restaurativa, prótesis.")
  );
  return (
    <>
      <PageHero eyebrow={tr("Services & procedures", "Servicios y procedimientos")} title={tr(<>Every smile, <span className="text-[#00C9B7]">complete care</span></>, <>Cada sonrisa, <span className="text-[#00C9B7]">atención integral</span></>)} img="/img/working.jpg" />
      <section className="pb-24 sm:pb-32"><div className="max-w-7xl mx-auto px-5 sm:px-8"><ServicesGrid /></div></section>
      <Reviews />
      <ContactBlock source="services" />
    </>
  );
}
